import React, { useMemo } from 'react';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import Modal from './Modal';
import { performSignOut } from '../security/signOut';
import { getAuthType } from '../security/authStorage';

interface InvalidSessionModalProps {
  isOpen: boolean;
}

const InvalidSessionModal: React.FC<InvalidSessionModalProps> = ({ isOpen }) => {
  // External (OHID/Benefit Central) users get their tab closed rather than
  // redirected to a login screen - see performSignOut() in security/signOut.ts.
  const isOhidUser = useMemo(() => getAuthType() === 'ohid', []);

  const getLogoutPage = async () => {
    await performSignOut();
  };

  return (
    <Modal
      isOpen={isOpen}
        onClose={getLogoutPage}
        title="Your Session is Invalid"
        ariaLabelledBy="invalid-session-dialog-title"
        ariaDescribedBy="invalid-session-dialog-description"
        maxWidth="sm"
        showCloseButton={false}
        actions={
          <Button onClick={getLogoutPage} variant="contained" color="primary">
            {isOhidUser ? 'Close tab' : 'Proceed to login'}
          </Button>
        }
      >
        <DialogContentText id="invalid-session-dialog-description">
          {isOhidUser
            ? 'Your session is no longer valid. Please close this tab.'
            : 'Please login again to continue.'}
        </DialogContentText>
      </Modal>
  );
};

export default InvalidSessionModal;
